"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M11 3v10H8l4 4 4-4h-3V3zM4 19h16v2H4z"
}), 'VerticalAlignBottomTwoTone');